export default {
  //
  //  Local name of the language
  //
  languageLocalName: 'English',

  //
  // General
  //
  changeLanguage: 'Change Language',
  supportMe: 'Support BadTranslator',
  shareButtonTitle: 'Share this page',
  subtitle: 'The <em>Telephone</em> game but with online translators. <br />Translate your message through multiple languages and back.',
  selectLanguage: 'Select language of your input',
  translationRoundsHelp: 'Select how many rounds of translation you like.',
  translationRounds: 'Translate {n} times',
  useExample: 'Use an example',
  textInputPlaceholder: 'Input any text to translate',
  translateButton: 'Translate!',
  shareTranslation: 'Share this translation',
  shareTranslationTitle: 'This is what happens when you translate through random languages',
  tryAgain: 'Try it again with other languages!',
  tryAgainDescription: 'Too crazy? 👉 Try lowering the rounds of translation.<br />Not crazy enough? 👉 Try increasing the number of rounds.<br />Tip for non-english speakers: 💡 Enter an english text but select your language from the dropdown.',
  howItWorksTitle: 'How does it work?',
  howItWorksParagraph1: 'This site is based on the\
      <em>telephone</em> game (also called <em>Chinese Whispers</em>), a game in which one participant comes up with a message and whispers it into the ear of the next person which in turn has to relay it to the next person from memory. With each person the message will become slightly altered so that it often leads to hilarious results when the last person has the say it out loud. This site is a digital version of this game, but instead of whispering the message from person to person, it is translated through multiple languages by a computer.',
  supportModalTitle: 'Hi there',
  supportModalText: "Sorry to bother you but I see you already used BadTranslator {translationCount} times. I hope you enjoy this app and had a few good laughs 😊\
      <br />This site will always be free but the online translation services that I am using in the background sadly are not free to me.\
      <br />\
      <br />If you like this app please consider donating so I can keep this service running.",
  supportModalThanks: "If you can't afford to donate that's totally fine but please consider telling your friends about BadTranslator.\
      <br />Thank you very much for your support and have fun!",
  donateOnX: "Donate on {x}",
  alreadyDonated: 'I already donated',
  thinkingAboutDonating: "I'll think about it",
  wontDonate: 'Go away',

  shareTitle: 'Play the BadTranslator game',
  shareText: 'On BadTranslator.net you can play the "Telephone Game" with online translators. Translate your text through random languages and see what comes out.',
  donateTextColumn: 'Running BadTranslator is not cheap.<br/> If you have fun please consider donating to help me cover my costs and upgrade the server.<br/>Thanks.',
};
